import React from 'react';

const Arrow = () => (
	<svg xmlns="http://www.w3.org/2000/svg" className="arrow" fill="none" viewBox="0 0 50 97"><path fill="#146FB4" d="M3.668.59a2 2 0 0 1 1.71 2.254C3.811 14.24 4.1 31.962 10.005 47.97c5.4 14.638 15.431 27.725 33.007 33.437l-6.826-10.9a2 2 0 0 1 3.39-2.124L49.13 83.64a2 2 0 0 1-.633 2.757L33.24 95.95a2 2 0 1 1-2.123-3.39l11.371-7.121c-19.45-6.046-30.454-20.41-36.236-36.083C.065 32.583-.216 14.17 1.414 2.299A2 2 0 0 1 3.668.59Z" /></svg>
);

export default Arrow;
